module.exports = __webpack_public_path__ + "img/vip_badge_5.2fa73de5.png";